import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boolean',
})
export class BooleanPipe implements PipeTransform {
  transform(value: Boolean): any {
    return value ? 'Yes' : 'No';
  }
}
